import axios from '../../../lib/axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const locationService = {
  // Get countries list
  getCountries: async (query = '') => {
    try {
      const url = query
        ? `${API_BASE_URL}/countries?q=${encodeURIComponent(query)}`
        : `${API_BASE_URL}/countries`;

      console.log('Fetching countries:', url);
      const response = await axios.get(url);
      console.log('Countries response:', response.data);

      if (response.data.status && response.data.data) {
        return response.data.data.map(country => ({
          id: country.country_id,
          name: country.country_name,
          code: country.country_code,
          phonecode: country.phonecode
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching countries:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch countries');
    }
  },

  // Get states by country ID
  getStates: async (countryId, query = '') => {
    try {
      let url = `${API_BASE_URL}/states?country_id=${countryId}`;
      if (query) {
        url += `&q=${encodeURIComponent(query)}`;
      }

      console.log('Fetching states:', url);
      const response = await axios.get(url);
      console.log('States response:', response.data);

      if (response.data.status && response.data.data) {
        return response.data.data.map(state => ({
          id: state.state_id,
          name: state.state_name,
          country_id: state.country_id,
          country_code: state.country_code
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching states:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch states');
    }
  },

  // Get cities by country ID and state ID
  getCities: async (countryId, stateId, query = '') => {
    try {
      let url = `${API_BASE_URL}/cities?country_id=${countryId}&state_id=${stateId}`;
      if (query) {
        url += `&q=${encodeURIComponent(query)}`;
      }

      console.log('Fetching cities:', url);
      const response = await axios.get(url);
      console.log('Cities response:', response.data);

      if (response.data.status && response.data.data) {
        return response.data.data.map(city => ({
          id: city.city_id,
          name: city.city_name,
          country_id: city.country_id,
          state_id: city.state_id,
          state_name: city.state_name,
          country_code: city.country_code
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching cities:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch cities');
    }
  },

  // Get site request list
  getSiteRequests: async () => {
    try {
      console.log('Fetching site requests:', `${API_BASE_URL}/site-request/list`);
      const response = await axios.get(`${API_BASE_URL}/site-request/list`);
      console.log('Site requests response:', response.data);

      if (response.data.status && response.data.data) {
        return response.data.data.map(site => ({
          id: site.site_id,
          name: site.site_name
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching site requests:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch site requests');
    }
  },

  // Get roles list
  getRoles: async () => {
    try {
      console.log('Fetching roles:', `${API_BASE_URL}/roles/list`);
      const response = await axios.get(`${API_BASE_URL}/roles/list`);
      console.log('Roles response:', response.data);

      if (response.data.status && response.data.data) {
        return response.data.data.map(role => ({
          id: role.role_id,
          name: role.role_name
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching roles:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch roles');
    }
  },

  // Get purposes list
  getPurposes: async () => {
    try {
      console.log('Fetching purposes:', `${API_BASE_URL}/purposes/list`);
      const response = await axios.get(`${API_BASE_URL}/purposes/list`);
      console.log('Purposes response:', response.data);

      if (response.data.status && response.data.data) {
        return response.data.data.map(purpose => ({
          id: purpose.purpose_id,
          name: purpose.display_name
        }));
      }
      return [];
    } catch (error) {
      console.error('Error fetching purposes:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch purposes');
    }
  }
};

export default locationService;
